/**
 * Suffixes which can be applied to the end of numbers.
 * @enum {string}
 */
export const NumericSuffix = {
  PERCENT: '%',
};

export const defaultDecimalPrecision = 2;
